import moment from 'moment';

export const handleDescription = (statusUpdatedAt) => {
	if (statusUpdatedAt) {
		const parsedDate = moment(statusUpdatedAt);
		return parsedDate.format('DD/MM/YYYY HH:mm:ss A');
	}
	return '--'
};
